import React, { useEffect } from "react";
import { RouterProvider, Route, createHashRouter, createRoutesFromElements } from "react-router-dom";
import ContolledExpandedNode from "./components/Home" 
import Ania from "./components/Ania";
import DwustronnaAnia from "./components/DwustronnaAnia";
import DwustronnaKuba from "./components/DwustronnaKuba";
import Rozklady from "./components/Distribution"
import { MainLayout } from "./components/MainLayout";

function App() {
    useEffect(() => {
      document.title = "System";
    }, []);

    const router = createHashRouter(
        createRoutesFromElements(
                <Route path="/" element={<MainLayout />}>
                <Route path="/kuba" element ={<ContolledExpandedNode />}/>     
                <Route path = "/ania"  element={<Ania />}/>
                <Route path = "/rozklady"  element={<Rozklady />}/> 
                <Route path = "/dwustronna"  element={<DwustronnaAnia />}/> 
                <Route path = "/dwustronnaKuba"  element={<DwustronnaKuba />}/> 
                {/* element={<ContolledExpandedNode />} */}
            </Route>
        )
    )

    return <RouterProvider router={router} />

}

export default App;
